import PropTypes from 'prop-types';
import React from 'react';

// Note: Using a local version of new CTA temporarily for now. Should eventually use ch.com lib version
import CTA from '../CTA/CTA';

import { getCtaProperties } from '@utils/ctaUtils';
import PostPageCTAStyles from './PostPageCTA.styled';

// We need to ensure parts of the CTA content are not displayed.
const getPostPageCtaProperties = (cta) => {
  let ctaProps = getCtaProperties(cta);

  // The post page CTAs do not display sub-heading text.
  ctaProps.subHeadingText = null;

  return ctaProps;
};

const getPostPageCTAs = (ctas) => {
  let cards = null;
  if (ctas) {
    cards = ctas.map((cta, i) => {
      return (
        <CTA
          {...getPostPageCtaProperties(cta)}
          key={`post-page-cta-${i}`}
          buttonAutomationId="cta-button-1"
          button2AutomationId="cta-button-2"
        />
      );
    });
  }

  if (cards.length < 1) {
    cards = null;
  }
  return cards;
};

const PostPageCTA = ({ ctas }) => {
  // Limiting to one CTA. Change if we need to support more CTAs
  const cards = ctas ? getPostPageCTAs(ctas.slice(0, 1)) : undefined;

  return (
    <PostPageCTAStyles>
      {cards ? (
        <div className="post-page-cta-container">
          <div className="post-page-cta-fullwidth">{cards}</div>
        </div>
      ) : null}
    </PostPageCTAStyles>
  );
};

PostPageCTA.propTypes = {
  ctas: PropTypes.array,
};

export default PostPageCTA;
